import React, { useState } from "react";
import DashboardLayout from "@/src/components/layout/DashboardLayout";

import HealthPackageCard from "../../src/components/health-package/HealthPackageCard";
import { useRouter } from "next/router";

import { testApiService } from "@/src/lib/api-services/testApiServices";
import useBreakpoint from "@/src/lib/util/custom-hooks/useBreakPoint";
import TextField from "@/src/components/custom-fields/TextField";

const HealthPackages = ({ data }) => {
    const { healthPackages } = data || {};
    const [searchQuery, setSearchQuery] = useState("");
    const router = useRouter();
    const isMobile = useBreakpoint("sm");

    // Handle search input
    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value.toLowerCase());
    };

    // Filter health packages based on the search query
    const filteredPackages = healthPackages?.filter((pkg) =>
        pkg.productName.toLowerCase().includes(searchQuery)
    );

    const handleViewMoreClick = (slug) => {
        router.push(`/test/${slug}`);
    };

    return (
        <div className="max-w-7xl mx-auto px-3 md:px-8">
            {/* Heading */}
            <h1 className="text-xl md:text-2xl font-bold text-black my-4 md:my-8 text-center">
                Health Packages
            </h1>

            {/* Search Bar */}
            <TextField
                size={isMobile ? "small" : "medium"}
                variant="outlined"
                fullWidth
                placeholder="Search Health Packages"
                value={searchQuery}
                onChange={handleSearchChange}
                className="md:mb-6 mb-4"
            />

            {/* Grid Layout */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6 justify-items-center">
                {filteredPackages?.length > 0 ? (
                    filteredPackages.map((pkg, index) => (
                        <HealthPackageCard
                            key={index}
                            pkg={pkg}
                            onViewMoreClick={handleViewMoreClick}
                        />
                    ))
                ) : (
                    <h6 className="text-center text-gray-400 col-span-full">
                        No health packages found.
                    </h6>
                )}
            </div>
        </div>
    );
};

export default HealthPackages;

HealthPackages.getLayout = (page) => <DashboardLayout>{page}</DashboardLayout>;

export async function getServerSideProps() {
    let healthPackages = null;

    try {
        const response = await testApiService.getHealthPackages();
        healthPackages = response?.data || [];
    } catch (error) {
        console.error("Failed to fetch health packages:", error);
    }

    return {
        props: {
            data: {
                healthPackages,
                seoTitle: "Health Packages | Full Body Checkup Near Me | HOD",
                seoDescription:
                    "Search health package for full body checkup or specialized profiles. Avail home sample collection. Extensive range of packages to suit your needs. Find check up price, information, preparation and book tests online.",
                routerPath: "health-packages",
            },
        },
    };
}
